module.exports = __webpack_public_path__ + "img/kjrc-rczc.8d2314d2.jpg";